module.exports = {
          srcSet: __webpack_public_path__ + "images/2001-1decd4167f970f1c20019cce80985008-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/2001-7179a500499767680aa87a6bdcf95214-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/2001-1decd4167f970f1c20019cce80985008-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/2001-7179a500499767680aa87a6bdcf95214-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/2001-1decd4167f970f1c20019cce80985008-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/2001-1decd4167f970f1c20019cce80985008-320.jpg"},
          
          width: 320,
          height: 251
        }